import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { CopyToClipboard } from "react-copy-to-clipboard";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";
import ArchiveIcon from "@material-ui/icons/Archive";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
import FindTotalInterest from "../PropView/helper-functions/FindTotalInterest";
import { createAcct } from "../PropView/api/LightReach";
import RECCalc from "../UsageFunctions/RECCalc";
import AuthGroupWrapper from "../Auth/AuthGroupWrapper";
import proposalToolApi from "../../Components/PropView/api/proposal-tool-api";
import Alert from "react-s-alert";
import "./Proposals.css";

// * Components
import { Adders } from "./components/Adders";
import { LoanAmount } from "./components/LoanAmount";

// * Libs
import { getAdditionalAdders } from "./lib/getAdditionalAdders";

// * API
import {
  getProposals,
  getCustomerInfo,
  addSrec,
  createQuote,
} from "./api/proposalsApi";
import goodLeapApi from "../../api/goodleap-api";
import auroraApi from "../../api/aurora-api";
import { Modal } from "../../shared/components/modal/Modal";
import AuroraDesignListModal from "../PropView/components/Modals/AuroraDesignListModal";

// This is the list of proposals underneath the "Dashboard"
// the place where we sync them in the current proposal

const Proposals = (props) => {
  const [proposal, setProposal] = useState([]);
  const [customer, setCustomer] = useState("");
  // eslint-disable-next-line
  const [copied, setCopied] = useState(false);
  // eslint-disable-next-line
  const [rebate, setRebate] = useState("");
  const [cutTree, setCutTree] = useState("");
  const [treeAmount] = useState("");
  const [basePpw, setBasePpw] = useState("");
  const [viewDesignImage, setViewDesignImage] = useState(null);
  const [glDvChangeOrderModal, setGlDvChangeOrderModal] = useState(null);
  const [glDvChangeOrderLoading, setGlDvChangeOrderLoading] = useState(false);
  const [glDvChangeOrderResponse, setGlDvChangeOrderResponse] = useState(null);
  const [glFullChangeOrderModal, setGlFullChangeOrderModal] = useState(null);
  const [glFullChangeOrderLoading, setGlFullChangeOrderLoading] = useState(false);
  const [glFullChangeOrderResponse, setGlFullChangeOrderResponse] = useState(null);
  const [showAuroraDesignModal, setShowAuroraDesignModal] = useState(false);
  const [auroraDesignList, setAuroraDesignList] = useState([]);
  const [auroraLoading, setAuroraLoading] = useState(false);
  const [currentAuroraProposal, setCurrentAuroraProposal] = useState(null);

  const [adderAmount] = useState(800);
  const [travelAmount] = useState(0.1);
  // const [dealerFee] = useState(.70)
  // const [dealerFeeHome] = useState(0.72);
  const [eto, setEto] = useState("No");
  const [syncLoading, setSyncLoading] = useState(false);
  // const [surveys] = useState([])

  const {
    storyAmount,
    surveys,
    team,
    propCloning,
    adders,
    syncPropId,
    sharedHome,
    trenching,
    meterAgg,
    imagery,
    addon,
    usageType,
    designLimited,
    city,
    roofQuote,
    setRoofQuote,
    setProposals,
    utilityLseId,
    maxOverDrive,
    lightReachAccountId,
    state,
    utilityPpa,
  } = props;

  const total = (arr) => arr.reduce((a, b) => a + b);
  const apiUrl = proposalToolApi.getUrl();

  // * API METHOD
  const getProposalsByProjectId = async () => {
    try {
      const res = await getProposals(props.projectID);

      if (Object.keys(res.data.roofQuote).length > 0) {
        setRoofQuote(res.data.roofQuote);
      }
      setProposal(res.data.data);
      setProposals(res.data.data.length);
    } catch (error) {
      console.error("Failed to fetch proposals:", error);
    }
  };

  const {
    setUtility,
    setCostOverRide,
    setPartialPanels,
    setPartialRebate,
    setSustainable,
    setRebateOverride,
    setRebateOverrideAmt,
    setOverRide,
    setPanelAmount,
    setMaxModCount,
    setArrayCount,
    setPpw,
    setPropPpw,
    setClone,
    setDownPayment,
    setDealerFee,
    setIonRebate,
    setBlkAdder,
    setBallast,
    setBallastPanels,
    setPartialBallast,
    setGroundMount,
    setGroundMountPanels,
    setPartialGroundMount,
    setPSolar,
    setMsp,
    setBattery3,
    setBattery10,
    setCritterGuard,
    setTravel,
    setTravelAmount,
    setReRoof,
    setReRoofAmount,
    setRoofSqFt,
    setRoofType,
    setSheathing,
    setTreeRemoval,
    setTreeRemovalAmount,
    setSameDay,
    setPreferredUtility,
    setReferral,
    setJanProduction,
    setFebProduction,
    setMarProduction,
    setAprProduction,
    setMayProduction,
    setJunProduction,
    setJulyProduction,
    setAugProduction,
    setSepProduction,
    setOctProduction,
    setNovProduction,
    setDecProduction,
    setNest,
    setNestAdder,
    setImg,
    setLoanA,
    setLoanB,
    setMod,
    setInverter,
    setRateOverRide,
    setRateOverRideAmount,
    setSmartHome,
    setHvac,
    setLed,
    setTurf,
    setWindows,
    setWater,
    setSmartHomeAmount,
    setHvacAmount,
    setLedAmount,
    setTurfAmount,
    setWindowsAmount,
    setUtilityReview,
    setUtilityReviewAmount,
    setWaterAmount,
    setViewAdders,
    setMilitary,
    setMiscCash,
    setMiscCashAmount,
    setMiscCashNotes,
    setBlackFriday,
    setHasRebate,
    setBallastAmount,
    setCritterGuardAmount,
    setNewMspAmount,
    setPSolarAmount,
    setBattery10Amount,
    setGroundMountAmount,
    setAddShadeWaiver,
    setViewOptions,
    setPanelBonus,
    setHasRec,
    setPvSystemAddOn,
    setPvSystemAddOnAmount,
    setExpansionPack,
    setExpansionPackAmount,
    setWaterSoftener,
    setWaterSoftenerAmount,
  } = propCloning;

  // const onCopy = () => {
  //   setCopied(true)
  // }

  // useEffect(()=> {
  //   setBasePpw(props.basePpw)
  // },[props.basePpw])

  useEffect(() => {
    if (+team.ppw > 0) {
      return setBasePpw(+team.ppw);
    }
  }, [team.ppw]);

  useEffect(() => {
    if (customer.setter === false) {
      if (customer.utility === "Austin Energy") {
        return setBasePpw(basePpw);
      }
      if (customer.utility === "City Public Service (CPS)") {
        return setBasePpw(basePpw);
      }
      if (
        team.salesTeam === "Las Vegas Sales Team II" ||
        team.salesTeam === "Las Vegas Sales Team 3"
      ) {
        return setBasePpw(basePpw);
      }
      setBasePpw(+basePpw - 0.2);
    }
    setBasePpw(props.basePpw);
  }, [customer.setter, props.basePpw]);

  // console.log(basePpw)

  useEffect(() => {
    if (props.projectID) {
      getProposalsByProjectId();
    }
  }, [props.projectID, props.view]);

  useEffect(() => {
    if (props.projectID) {
      const getCustomer = async () => {
        try {
          const res = await getCustomerInfo(props.projectID);
          setCustomer(res.data.data);
        } catch (error) {
          console.error("Failed to fetch customer info:", error);
        }
      };
      getCustomer();
    }
  }, [props.projectID]);

  useEffect(() => {
    setRebate(proposal.rebate);
  }, [proposal]);

  let highLoanProp = 0;

  let adderIds = [];

  for (let i = 0; i < adders.length; i++) {
    adderIds.push(adders[i].id);
  }

  const [active, setActive] = useState(1);

  const adderToggle = (num, operation) => {
    if (num === 1) {
      return operation(0);
    }
    operation(1);
  };

  // * API METHOD - Get Aurora Designs
  const getAuroraDesigns = async (proposalData) => {
    setAuroraLoading(true);
    setCurrentAuroraProposal(proposalData);
    try {
      const res = await auroraApi.getDesignsForProject({
        projectId: proposalData.projectId
      });

      if (res.success) {
        if(res.data.designs && res.data.designs.length > 0){
          setAuroraDesignList(res.data.designs);
          setShowAuroraDesignModal(true);
        } else {
          Alert.error("No Aurora designs found for this project.");
        }
      }
    } catch (error) {
      console.error("Error in getAuroraDesigns:", error);
      Alert.error("Failed to get Aurora designs. Please try again.");
    } finally {
      setAuroraLoading(false);
    }
  };

  // * API METHOD - Sync Aurora Design
  const getAuroraDesignData = async (proposalData) => {
    setAuroraLoading(true);
    try {
      await auroraApi.syncDesign({
        projectId: proposalData.projectId,
        propId: proposalData.propId,
      });
      // Refresh proposals after sync
      getProposalsByProjectId();
      Alert.success("Aurora design synced successfully", {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 3000,
        offset: 100,
        color: "rgba(255, 255, 255, 0.927)",
      });
    } catch (error) {
      console.error("Error syncing Aurora design:", error);
      Alert.error("Failed to sync Aurora design. Please try again.");
    } finally {
      setAuroraLoading(false);
      setShowAuroraDesignModal(false);
    }
  };

  let mappedProposals = proposal
    .filter((option) => {
      return +option.isActive === active;
    })
    .map((proposal, i) => {
      const {
        jan,
        feb,
        mar,
        apr,
        may,
        june,
        july,
        aug,
        sept,
        oct,
        nov,
        december,
        januaryUsage,
        februaryUsage,
        marchUsage,
        aprilUsage,
        mayUsage,
        juneUsage,
        julyUsage,
        augustUsage,
        septemberUsage,
        octoberUsage,
        novemberUsage,
        decemberUsage,
        auroraDesignId,
      } = proposal;
      let production = [
        +jan,
        +feb,
        +mar,
        +apr,
        +may,
        +june,
        +july,
        +aug,
        +sept,
        +oct,
        +nov,
        +december,
      ];
      let propUsage = [
        +januaryUsage,
        +februaryUsage,
        +marchUsage,
        +aprilUsage,
        +mayUsage,
        +juneUsage,
        +julyUsage,
        +augustUsage,
        +septemberUsage,
        +octoberUsage,
        +novemberUsage,
        +decemberUsage,
      ];
      let totalProduction = total(production);
      let totalPropUsage = total(propUsage);
      let batteryType;
      let nestMax = 0.05;
      let nestAmount = 2076;
      let eto = "NO";
      let sync = false;
      let batteryString = "Battery";
      let groundMountString = "Ground Mount";
      let ballastAmount = 0.27;
      let critterGuardAmount = 0.1;
      let pvSystemAddOnAmount = 0;
      let mspAmount = 1500;
      let pSolarAmount = 0.15;
      let battery10Amount = 18000;
      let groundMountAmount = 1.3;
      let freePowerAmount = proposal.payment1 * 6;
      let dealerFee = proposal.dealerfee1;

      // if (+proposal.id1 === 115) {
      //   dealerFee = 1;
      // }

      // console.log(dealerFee)

      if (proposal.payment1 * 6 >= 1000) {
        freePowerAmount = 1000;
      }

      if (+proposal.ballastAmount > 0) {
        ballastAmount = +proposal.ballastAmount;
      }
      if (+proposal.critterGuardAmount > 0) {
        critterGuardAmount = +proposal.critterGuardAmount;
      }
      if (+proposal.mspAmount > 0) {
        mspAmount = +proposal.mspAmount;
      }
      if (+proposal.pSolarAmount > 0) {
        pSolarAmount = +proposal.pSolarAmount;
      }
      if (+proposal.battery10Amount > 0) {
        battery10Amount = +proposal.battery10Amount;
      }
      if (+proposal.groundMountAmount > 0) {
        groundMountAmount = +proposal.groundMountAmount;
      }
      if (+proposal.pvSystemAddOnAmount > 0) {
        pvSystemAddOnAmount = +proposal.pvSystemAddOnAmount;
      }
      let interest = FindTotalInterest(
        proposal.pre1,
        proposal.post1,
        proposal.term1,
        proposal.loanAmount,
        proposal.loan1,
      );
      let numOfPayments = proposal.term1 * 12;

      const monthly = `v${i + 1} Monthly Production --- January - ${jan}, 
    February - ${feb}, 
    March - ${mar},
    April - ${apr},
    May - ${may},
    June - ${june},
    July - ${july},
    August - ${aug},
    September - ${sept},
    October - ${oct},
    November - ${nov},
    December - ${december}`;

      const propV = i + 1;
      // need to set up the clone with partialBallast and ballastPanels. Need to set partialBallast to 1 if ballastPanels < panelAmount

      const findBallast = () => {
        if (
          +proposal.ballastModules < +proposal.modCount &&
          +proposal.ballastModules > 0
        ) {
          return 1;
        }
        return 0;
      };

      const findGroundMount = () => {
        if (
          +proposal.groundMountModules < +proposal.modCount &&
          +proposal.groundMountModules > 0
        ) {
          return 1;
        }
        return 0;
      };

      const findAdders = () => {
        if (
          +proposal.hvac === 1 ||
          +proposal.led === 1 ||
          +proposal.smartHome === 1 ||
          +proposal.turf === 1 ||
          +proposal.windows === 1 ||
          +proposal.water === 1
        ) {
          return 1;
        }
        return 0;
      };

      const findRebate = () => {
        if (
          proposal.rebatePanels < proposal.modCount &&
          proposal.rebatePanels > 0
        ) {
          return 1;
        }
        return 0;
      };

      const findRebateOverride = () => {
        if (+proposal.rebateOverride === 1 || +proposal.costOverRide === 1) {
          return setOverRide(true);
        }
        return setOverRide(false);
      };

      if (+proposal.battery10 > 0) {
        batteryType = "Encharge 10";
      }

      if (proposal.hasNest) {
        nestMax = 0.05;
      }

      if (totalPropUsage * nestMax < nestAmount) {
        nestAmount = totalPropUsage * nestMax;
      }

      // const findEto = () => {
      // if (proposal.utility === 'Pacific Power' || proposal.utility === 'Portland General Electric (PGE)') {
      //   if (+proposal.rebateSF > 0) {
      //     eto = "YES"
      //   }
      // }
      // }

      // console.log(i + 1, eto)

      // console.log(i + 1, batteryType)

      // const overRider = () => {
      //   if (proposal.rebateOverride === '1') {
      //     return +proposal.ppw
      //   } return ''
      // }

      if (proposal.utilityLocation === "Nevada") {
        if (proposal.id1 === "32" || proposal.id1 === "45") {
          highLoanProp = 0.15;
        }
        highLoanProp = 0;
      }

      let surveyTypes = [];
      if (+proposal.battery10 > 0) {
        surveyTypes.push(batteryString);
      }
      if (+proposal.groundMount === 1) {
        surveyTypes.push(groundMountString);
      }

      let siteSurveyTypes = surveyTypes.concat(surveys);

      // console.log(siteSurveyTypes, siteSurveyTypes.join(';'))

      let designTypes = [];

      if (+proposal.ballast === 1) {
        if (findBallast() === 1) {
          designTypes.push("Mixed Mounting Hardware");
        }
        designTypes.push("Ballast");
      }
      if (+proposal.groundMount === 1) {
        if (findGroundMount() === 1) {
          designTypes.push("Mixed Mounting Hardware");
        }
        designTypes.push("Ground Mount");
      }
      if (+proposal.battery10 > 0) {
        designTypes.push("Battery");
      }
      if (+sharedHome === 1) {
        designTypes.push("MultiFamily/Shared Roofs");
      }
      if (+trenching === 1) {
        designTypes.push("Electrical Trenching");
      }
      if (+meterAgg === 1) {
        designTypes.push("Digital Meter Aggregation");
      }
      if (+imagery === 2) {
        designTypes.push("Roof Measurements");
      }
      if (+addon === 1) {
        designTypes.push("Add-on");
      }

      const totalOverRider = () => {
        if (proposal.costOverRide === "1") {
          return (
            setCostOverRide(
              +(
                proposal.ppw * proposal.systemSize +
                +proposal.adderTotal
              ).toFixed(2),
            ) && props.setBasePpw("")
          );
        }
        if (proposal.rebateOverride === "1") {
          return props.setBasePpw(+proposal.ppw) && setCostOverRide("");
        }
        return "";
      };

      const cloneProp = () => {
        setClone(1);
        setUtility(proposal.utility);
        props.setPropRebate(+proposal.rebate);
        setHasRebate(+proposal.rebateOverride);
        setRebateOverride(+proposal.rebateOverride);
        setRebateOverrideAmt(+proposal.rebate);
        totalOverRider();
        findRebateOverride();
        setBallastPanels(+proposal.ballastModules);
        setPartialBallast(findBallast());
        setGroundMountPanels(+proposal.groundMountModules);
        setPartialGroundMount(findGroundMount());
        setPartialRebate(findRebate());
        setPartialPanels(+proposal.rebatePanels);
        setPanelAmount(+proposal.modCount);
        setMaxModCount(+proposal.maxModCount);
        setArrayCount(+proposal.arrayCount);
        setLoanA([
          +proposal.id1,
          proposal.loan1,
          proposal.term1,
          +proposal.int1,
          +proposal.pre1,
          +proposal.post1,
          +proposal.interest1,
          +proposal.itc1,
          +proposal.specialPrice1,
          +proposal.dealerfee1,
        ]);
        setLoanB([
          +proposal.id2,
          proposal.loan2,
          proposal.term2,
          +proposal.int2,
          +proposal.pre2,
          +proposal.post2,
          +proposal.interest2,
          +proposal.itc2,
          +proposal.specialPrice2,
          +proposal.dealerfee2,
        ]);
        setMod([
          proposal.modId,
          proposal.module,
          proposal.mod_model,
          proposal.modSize,
          proposal.modPtcRating,
        ]);
        setInverter([
          proposal.invId,
          proposal.invType,
          proposal.invModel,
          proposal.invRating,
        ]);
        setDealerFee(+proposal.dealerfee1);
        setDownPayment(+proposal.downPayment);
        setIonRebate(+proposal.ionRebate);
        setBlkAdder(+proposal.ionRebate2);
        setBallast(+proposal.ballast);
        setGroundMount(+proposal.groundMount);
        setPSolar(+proposal.pSolar);
        setMsp(+proposal.msp);
        setCritterGuard(+proposal.critterGuard);
        setBattery3(+proposal.battery3);
        setBattery10(+proposal.battery10);
        setTravel(+proposal.travel);
        setTravelAmount(+proposal.travelAmount);
        setTreeRemoval(+proposal.treeTrim);
        setTreeRemovalAmount(+proposal.treeTrimAmount);
        setReRoof(+proposal.reroof);
        setReRoofAmount(+proposal.reroofAmount);
        setRoofSqFt(+roofQuote.roofSqFt || 0);
        setRoofType(roofQuote.roofType || "");
        setSheathing(false);
        setMilitary(+proposal.military);
        setMiscCash(+proposal.miscCash);
        setMiscCashAmount(+proposal.miscCashAmount);
        setMiscCashNotes(proposal.miscCashNotes);
        setAddShadeWaiver(+proposal.shadeWaiver);
        setViewOptions(+proposal.optionsView);
        setBlackFriday(+proposal.blackFriday);
        setSameDay(+proposal.sameDay);
        setPreferredUtility(+proposal.preferredUtility);
        setReferral(+proposal.referral);
        setSustainable(+proposal.sustainable);
        setJanProduction(+proposal.jan);
        setFebProduction(+proposal.feb);
        setMarProduction(+proposal.mar);
        setAprProduction(+proposal.apr);
        setMayProduction(+proposal.may);
        setJunProduction(+proposal.june);
        setJulyProduction(+proposal.july);
        setAugProduction(+proposal.aug);
        setSepProduction(+proposal.sept);
        setOctProduction(+proposal.oct);
        setNovProduction(+proposal.nov);
        setDecProduction(+proposal.december);
        setNest(+proposal.hasNest);
        setNestAdder(+proposal.hasNestAdder);
        setImg(proposal.design);
        setRateOverRide(+proposal.rateOverRide);
        setRateOverRideAmount(+proposal.rateAmount);
        setPpw(+proposal.ppw);
        setSmartHome(+proposal.smartHome);
        setHvac(+proposal.hvac);
        setLed(+proposal.led);
        setTurf(+proposal.turf);
        setWindows(+proposal.windows);
        setUtilityReview(+proposal.utilityReview);
        setUtilityReviewAmount(+proposal.utilityReviewAmount);
        setWater(+proposal.water);
        setSmartHomeAmount(+proposal.smartHomeAmount);
        setHvacAmount(+proposal.hvacAmount);
        setLedAmount(+proposal.ledAmount);
        setTurfAmount(+proposal.turfAmount);
        setWindowsAmount(+proposal.windowsAmount);
        setWaterAmount(+proposal.waterAmount);
        setViewAdders(findAdders());
        setPanelBonus(+proposal.panelBonus);
        setHasRec(+proposal.srec);
        setPvSystemAddOn(+proposal.pvSystemAddOn);
        setExpansionPack(+proposal.expansionPack);
        setExpansionPackAmount(+proposal.expansionPackAmount);
        setWaterSoftener(+proposal.waterSoftener);
        setWaterSoftenerAmount(+proposal.waterSoftenerAmount);
        if (+proposal.ballastAmount > 0) {
          setBallastAmount(+proposal.ballastAmount);
        }
        if (+proposal.critterGuardAmount > 0) {
          setCritterGuardAmount(+proposal.critterGuardAmount);
        }
        if (+proposal.mspAmount > 0) {
          setNewMspAmount(+proposal.mspAmount);
        }
        if (+proposal.pSolarAmount > 0) {
          setPSolarAmount(+proposal.pSolarAmount);
        }
        if (+proposal.battery10Amount > 0) {
          setBattery10Amount(+proposal.battery10Amount);
        }
        if (+proposal.groundMountAmount > 0) {
          setGroundMountAmount(+proposal.groundMountAmount);
        }
        if (+proposal.pvSystemAddOnAmount > 0) {
          setPvSystemAddOnAmount(+proposal.pvSystemAddOnAmount);
        }
      };

      // console.log(i, proposal.loan1, prePmt1, postPmt1, intPmt1)
      // console.log(i, cash)

      let loanSource = proposal.loan1;
      let loanProduct = `Single ${proposal.term1}yr ${proposal.int1}%`;

      if (proposal.loan1?.toLowerCase() === "goodleap") {
        loanSource = "LoanPal";
      }
      if (proposal.loan1 === "Owner Financing") {
        loanProduct = "";
      }
      if (+proposal.ppa1 === 1) {
        loanProduct = `${+proposal.ppaRate1 * 100} ${(
          proposal.ppaEscalator1 * 100
        ).toFixed(2)}%`;
      }

      // if(+proposal.int1 === 1.39){
      //   loanProduct = `Single ${proposal.term1}yr 1.49%`
      // }

      let recValue = {
        afterEnergy: 0,
        capacityFactor: 0,
        numRecs: 0,
        acSystem: 0,
        additionalCollateral: 0,
        utilityCollateral: 0,
        applicationFee: 0,
        grossValue: 0,
        product: 0,
      };

      let mod = [
        proposal.modId,
        proposal.module,
        proposal.mod_model,
        proposal.modSize,
        proposal.modPtcRating,
      ];

      if (["Illinois", "---", "Ohio", "Virginia"].includes(state)) {
        recValue = RECCalc(
          proposal.modCount,
          mod,
          proposal.invRating,
          totalProduction,
          state,
          proposal.loan1,
          +proposal.srec,
          proposal.utility,
        );
      }

      // * API METHOD
      const updateProposal = async () => {
        try {
          let createAcctResult;
          if (
            +utilityLseId > 0 &&
            utilityPpa &&
            +proposal.townhome !== 1 &&
            lightReachAccountId
          ) {
            createAcctResult = await createAcct(
              customer,
              totalProduction,
              proposal.systemSize,
              proposal.modCount,
              proposal.module,
              proposal.modSize,
              proposal.invType,
              proposal.invModel,
              utilityLseId,
              customer.lightReachProductId,
              +proposal.msp,
              +proposal.reroof,
              +proposal.battery10,
              +proposal.battery10Amount,
            );
          }
          let recResult;
          if (
            state === "Virginia" ||
            state === "Ohio" ||
            state === "Illinois"
          ) {
            recResult = await addSrec(
              recValue.product,
              recValue.afterEnergy,
              customer,
            );
          }
          // console.log(createAcctResult)
          const res = await axios.post(apiUrl, {
            method: "update_proposal",
            id: customer.financeId,
            of_Solar_Panels__c: proposal.modCount,
            Number_of_Inverters__c: proposal.invCount,
            Inverter_Make__c: proposal.invType,
            Inverter_Model__c: proposal.invModel,
            Solar_Panel_Make__c: proposal.module,
            Solar_Panel_Model__c: proposal.modSize,
            of_Arrays__c: proposal.arrayCount,
            Utility_Rebate__c: proposal.rebateSF,
            Primary_Financing_Amount__c:
              +proposal.ppa1 === 1
                ? proposal.ppaTotalAmount
                : proposal.loanAmount,
            System_Size__c: proposal.systemSize,
            id2: customer.designId,
            Secondary_Financing_Amount__c: proposal.downPayment,
            Est_Annual_Production__c: totalProduction,
            jan: jan,
            feb: feb,
            mar: mar,
            apr: apr,
            may: may,
            june: june,
            july: july,
            aug: aug,
            sept: sept,
            oct: oct,
            nov: nov,
            dec: december,
            id3: proposal.projectId,
            version: propV,
            ballast: +proposal.ballast,
            groundMount: proposal.groundMount,
            propId: proposal.propId,
            Offset__c: offset(),
            Plus_Minus_Panels__c: 0,
            Battery_Type__c: batteryType,
            State_Rebate_Project__c: eto,
            id4: customer.installId,
            id5: customer.projectID,
            of_Stories__c: storyAmount,
            survey: siteSurveyTypes.join(";"),
            rep_gen: +proposal.repGen,
            sharedHome,
            Financing_Source__c: loanSource,
            Financing_Product__c: loanProduct,
            Rebate_Type__c: installRebateType,
            designTypes: designTypes.join(";"),
            Roof_Space_Limited__c: designLimited,
            Shade_Waiver__c: proposal.shadeWaiver,
            Quote_ID__c: roofQuote.roofQuoteId,
            Roof_Square_Footage__c: roofQuote.roofSqFt,
            Roof_Type__c: roofQuote.roofType,
            Interest__c: interest,
            Total_Number_of_Payments__c: numOfPayments,
            Rebate_Project__c: state === "Illinois" && proposal.battery10 > 0,
          });

          Alert.success(`Proposal info added to Sales Force`, {
            position: "top-right",
            effect: "flip",
            beep: false,
            timeout: 5000,
            offset: 100,
            color: "rgba(255, 255, 255, 0.927)",
          });
          props.getCustomer();
          setSyncLoading(false);
        } catch (error) {
          console.error("Error updating proposal:", error);
        }
      };

      const goodLeapChangeOrder = async () => {
        try {
          await goodLeapApi.submitChangeOrder({
            sf_project_id: proposal.projectId,
          });
        } catch (error) {
          console.error("Error updating proposal:", error);
        }
      };

      // const syncAll = async () => {
      //   updateProposal()
      //   // await syncAdders()
      //   await props.getCustomer()
      // }

      // * API METHOD
      const updateSignedProposal = () => {
        axios
          .post(apiUrl, {
            method: "update_signed_proposal",
            id: customer.financeId,
            id2: customer.designId,
            Est_Annual_Production__c: totalProduction,
            jan: jan,
            feb: feb,
            mar: mar,
            apr: apr,
            may: may,
            june: june,
            july: july,
            aug: aug,
            sept: sept,
            oct: oct,
            nov: nov,
            dec: december,
            id3: proposal.projectId,
            version: propV,
            ballast: +proposal.ballast,
            groundMount: proposal.groundMount,
            propId: proposal.propId,
            Plus_Minus_Panels__c: 0,
            Offset__c: offset(),
          })
          .then((res) => {
            // updateProduction()
            // console.log(res.data)
            Alert.success(`Proposal info added to Sales Force`, {
              position: "top-right",
              effect: "flip",
              beep: false,
              timeout: 5000,
              offset: 100,
              color: "rgba(255, 255, 255, 0.927)",
            });
            props.getCustomer();
          });
      };
      // console.log(proposal.propId)

      // * API METHOD
      const treeTrim = () => {
        axios
          .post(apiUrl, {
            method: "add_tree_cut",
            id: customer.designId,
            Number_of_Trees_Removed__c: treeAmount,
          })
          .then((res) => {
            // updateProduction()
            // console.log(res.data)
            Alert.success(`# of trees to be trimmed updated in SF`, {
              position: "top-right",
              effect: "flip",
              beep: false,
              timeout: 5000,
              offset: 100,
              color: "rgba(255, 255, 255, 0.927)",
            });
          });
      };

      // * API METHOD
      const addHomeEnergyAll = () => {
        if (homeEnergyAdderCall.length > 0) {
          axios
            .post(apiUrl, {
              method: "add_home_energy_all",
              financing_id: customer.financeId,
              project_id: customer.projectID,
              adders: JSON.stringify(homeEnergyAdderCall),
            })
            .then((res) => {
              // console.log(res.data)
              props.getCustomer();
            });
        }
      };
      // * API METHOD
      const addTreeTrim = () => {
        axios
          .post(apiUrl, {
            method: "add_tree_trim",
            financing_id: customer.financeId,
            project_id: customer.projectID,
            Amount__c: proposal.treeTrimAmount * dealerFee,
          })
          .then((res) => {
            // console.log(res.data)
            props.getCustomer();
            Alert.success(`	Tree Trim/Removal added to Incentives`, {
              position: "top-right",
              effect: "flip",
              beep: false,
              timeout: 5000,
              offset: 100,
              color: "rgba(255, 255, 255, 0.927)",
            });
          });
      };

      let adderCall = [];
      let homeEnergyAdderCall = [];

      // Create a mapping of potential adders
      const energyUpgrades = [
        {
          key: "smartHome",
          label: "Smart Home Energy Efficiency Upgrade",
          amountKey: "smartHomeAmount",
        },
        {
          key: "hvac",
          label: "HVAC Energy Efficiency Upgrade",
          amountKey: "hvacAmount",
        },
        { key: "led", label: "LED Lighting", amountKey: "ledAmount" },
        {
          key: "turf",
          label: "Landscaping and Turf Energy Efficiency Upgrade",
          amountKey: "turfAmount",
        },
        {
          key: "windows",
          label: "Windows and Doors Energy Efficiency Upgrade",
          amountKey: "windowsAmount",
        },
        {
          key: "water",
          label: "Water Efficiency Upgrade",
          amountKey: "waterAmount",
        },
      ];

      // Dynamically add energy upgrades if applicable
      energyUpgrades.forEach(({ key, label, amountKey }) => {
        if (proposal[key] === "1") {
          homeEnergyAdderCall.push({
            adder: label,
            amount: proposal[amountKey] * dealerFee,
          });
        }
      });

      // Handle Nest Adder
      let nestType =
        +proposal.hasNestAdder === 1
          ? "Smart Thermostat +"
          : "Smart Thermostat";
      if (+proposal.hasNest > 0) {
        adderCall.push({
          adder: "hasNest",
          type: nestType,
          amount: +proposal.hasNest,
        });
      }

      // List of other adders based on conditions
      const additionalAdders = getAdditionalAdders(
        proposal,
        dealerFee,
        battery10Amount,
        mspAmount,
        freePowerAmount,
        ballastAmount,
        critterGuardAmount,
        pvSystemAddOnAmount,
        groundMountAmount,
        pSolarAmount,
        customer,
      );

      // Add the applicable adders to the call
      additionalAdders.forEach(({ condition, adder }) => {
        if (condition) adderCall.push(adder);
      });

      let installRebateType;

      if (+proposal.rebate > 0) {
        installRebateType = "Inspection";
        eto = "YES";
      }

      if (
        proposal.utility === "Pacific Power" ||
        proposal.utility === "Portland General Electric (PGE)"
      ) {
        if (+proposal.rebateSF > 0) {
          installRebateType = "State Application;State Inspection";
          eto = "YES";
        }
      }

      // * API METHOD
      const deleteProp = () => {
        axios
          .post(apiUrl, {
            method: "delete_prop",
            active: 0,
            prop_id: proposal.propId,
          })
          .then((res) => {
            // console.log(res.data)
            getProposalsByProjectId();
            Alert.success(`Proposal Removed`, {
              position: "top-right",
              effect: "flip",
              beep: false,
              timeout: 5000,
              offset: 100,
              color: "rgba(255, 255, 255, 0.927)",
            });
          });
      };

      // * API METHOD
      const syncProp = () => {
        axios
          .post(apiUrl, {
            method: "sync_prop",
            sync: 1,
            prop_id: proposal.propId,
          })
          .then((res) => {
            // console.log(res.data)
          });
      };

      // * API METHOD
      const activeProp = () => {
        axios
          .post(apiUrl, {
            method: "active_prop",
            active: 1,
            prop_id: proposal.propId,
          })
          .then((res) => {
            // console.log(res.data)
            getProposalsByProjectId();
          });
      };
      // * API METHOD
      // const unSignProp = () => {
      //   axios.post(`https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`, { method: 'sign_prop', signed: 0, prop_id: proposal.propId }).then((res) => {
      //     // console.log(res.data)
      //     getProposalsByProjectId()
      //     Alert.success(`Proposal unsigned`, {
      //       position: 'top-right',
      //       effect: 'flip',
      //       beep: false,
      //       timeout: 5000,
      //       offset: 100,
      //       color: 'rgba(255, 255, 255, 0.927)'
      //     })
      //   })
      // }

      // const syncing = () => {
      //   sync = true
      //   console.log('this working?')
      // }
      // console.log(props.designType)
      // console.log(proposal)

      const setCutTrees = () => {
        return (
          <>
            {treeAmount ? (
              <>
                <Link target="_blank" to={`/shade/${proposal.propId}/`}>
                  <button className="buttonChecked" onClick={() => treeTrim()}>
                    Shade Waiver
                  </button>
                </Link>
              </>
            ) : (
              <>
                <button
                  className="buttonUnchecked"
                  onClick={() => setCutTree(!cutTree)}
                >
                  Shade Waiver
                </button>
              </>
            )}
          </>
        );
      };

      const copier = () => {
        return Alert.success(
          `${proposal.systemSize / 1000}kW Rep Link Copied`,
          {
            position: "top-right",
            effect: "flip",
            beep: false,
            timeout: 5000,
            offset: 100,
            color: "rgba(255, 255, 255, 0.927)",
          },
        );
      };

      const offset = () => {
        if (usageType === "Square Footage") {
          return "0";
        }
        // if (+proposal.hasNest > 0) {
        //   return Math.round((totalProduction + nestAmount) / totalPropUsage * 100)
        // }
        if (totalPropUsage === 0) {
          return "0";
        }
        return Math.round((totalProduction / totalPropUsage) * 100);
      };
      // console.log(i+1, offset())

      // * mappedProposals return
      return (
        <div
          className="row rounded-3 mb-2 pe-2 pt-2 pb-2"
          key={i}
          value={module.mod_name}
          style={{
            backgroundColor: "#ffffff",
            border:
              +syncPropId !== +proposal.propId
                ? "1px solid #adadad"
                : "2px solid #139f00",
          }}
        >
          <div className="col-2">
            <img
              onClick={() => setViewDesignImage(proposal.propId)}
              src={proposal.design}
              role="button"
              style={{ cursor: "pointer", minHeight: "100px" }}
              className="img-fluid rounded-3 mb-2"
            />

            {/* sync with salesforce button*/}
            {!props.contractSigned ? (
              <>
                {syncLoading === true ? (
                  <>
                    <CircularProgress size={35} color="inherit" />
                  </>
                ) : (
                  <>
                    {+proposal.isActive === 1 &&
                    +syncPropId !== +proposal.propId ? (
                      <>
                        <button
                          type="button"
                          className="btn btn-sm btn-primary w-100"
                          onClick={() => {
                            updateProposal();
                            addHomeEnergyAll();
                            setSyncLoading(true);
                          }}
                        >
                          <i className="bi bi-arrow-repeat"></i> Sync with SF
                        </button>
                        {+syncPropId === +proposal.propId && (
                          <button
                            type="button"
                            className="btn btn-sm btn-info w-100 mt-1 text-white"
                            style={{ backgroundColor: "#856cff", borderColor: "#856cff" }}
                            disabled={auroraLoading}
                            onClick={() => getAuroraDesigns(proposal)}
                          >
                            {auroraLoading ? (
                              <CircularProgress size={15} color="inherit" />
                            ) : (
                              <>
                                <i className="bi bi-arrow-repeat"></i> Sync Aurora Design
                              </>
                            )}
                          </button>
                        )}
                      </>
                    ) : (
                      <>
                        <button
                          type="button"
                          className="btn btn-sm btn-secondary w-100"
                          disabled
                        >
                          <i className="bi bi-arrow-repeat"></i> Sync with SF
                        </button>
                        {+syncPropId === +proposal.propId && (
                          <button
                            type="button"
                            className="btn btn-sm btn-info w-100 mt-1 text-white"
                            style={{ backgroundColor: "#856cff", borderColor: "#856cff" }}
                            disabled={auroraLoading}
                            onClick={() => getAuroraDesigns(proposal)}
                          >
                            {auroraLoading ? (
                              <CircularProgress size={15} color="inherit" />
                            ) : (
                              <>
                                <i className="bi bi-arrow-repeat"></i> Sync Aurora Design
                              </>
                            )}
                          </button>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <>
                {+proposal.isActive === 1 ? (
                  <>
                    <button
                      type="button"
                      className="btn btn-sm btn-primary w-100"
                      onClick={() => {
                        updateSignedProposal();
                        syncProp();
                      }}
                    >
                      Sync Production with SF
                    </button>
                    {+syncPropId === +proposal.propId && (
                      <button
                        type="button"
                        className="btn btn-sm btn-info w-100 mt-1 text-white"
                        style={{ backgroundColor: "#856cff", borderColor: "#856cff" }}
                        disabled={auroraLoading}
                        onClick={() => getAuroraDesigns(proposal)}
                      >
                        {auroraLoading ? (
                          <CircularProgress size={15} color="inherit" />
                        ) : (
                          <>
                            <i className="bi bi-arrow-repeat"></i> Sync Aurora Design
                          </>
                        )}
                      </button>
                    )}
                  </>
                ) : (
                  <button
                    type="button"
                    className="btn btn-sm btn-success w-100"
                    disabled
                  >
                    Sync Production with SF
                  </button>
                )}

                <AuthGroupWrapper requiredGroups={["Super-Admin", "Proposals"]}>
                  <>
                    {maxOverDrive && +proposal.isActive === 1 ? (
                      <div className="propButton">
                        {syncLoading === true ? (
                          <CircularProgress size={35} color="inherit" />
                        ) : (
                          <button
                            onClick={() => {
                              updateProposal();
                              addHomeEnergyAll();
                              goodLeapChangeOrder();
                              setSyncLoading(true);
                            }}
                          >
                            Sync For Change Order
                          </button>
                        )}
                      </div>
                    ) : null}
                  </>
                </AuthGroupWrapper>
              </>
            )}

            <Modal
              isOpen={viewDesignImage === proposal.propId}
              onClose={() => setViewDesignImage(null)}
              title="Design Image"
              showCloseButton={true}
              closeOnOverlayClick={true}
            >
              <img
                src={proposal.design}
                alt="Design Image"
                style={{ width: "100%", height: "auto" }}
              />
            </Modal>
          </div>

          <div className="col-10">
            <div className="row">
              <div
                className="col-12 pt-2 pe-1 rounded-3 text-white"
                style={{
                  backgroundColor:
                    +syncPropId !== +proposal.propId ? "#212529" : "#006a00",
                }}
              >
                <span className="float-start">
                  <h5>
                    {+syncPropId === +proposal.propId ? (
                      <>
                        <i className="bi bi-check-circle-fill text-white"></i>{" "}
                      </>
                    ) : (
                      <>
                        <i className="bi bi-slash-circle text-secondary"></i>{" "}
                      </>
                    )}

                    <LoanAmount
                      utility={proposal.utility}
                      loanAmount={proposal.loanAmount}
                      rebate={proposal.rebate}
                      downPayment={proposal.downPayment}
                      id1={proposal.id1}
                      ppa1={proposal.ppa1}
                    />
                  </h5>
                </span>

                <span className="float-end ms-2" style={{ marginTop: "-4px" }}>
                  {+proposal.isActive === 0 ? (
                    <button
                      type="button"
                      className="btn btn-sm btn-success w-100"
                      onClick={() => activeProp()}
                    >
                      <i className="bi bi-plus-circle-fill"></i>
                    </button>
                  ) : +syncPropId !== +proposal.propId ? (
                    <button
                      type="button"
                      className="btn btn-sm btn-danger w-100"
                      onClick={() => deleteProp()}
                    >
                      <i className="bi bi-x-circle"></i>
                    </button>
                  ) : (
                    <>{""}</>
                  )}
                </span>

                <span
                  className="float-end"
                  style={{lineHeight:"10px",
                    color:
                      +syncPropId !== +proposal.propId ? "#b8b8b8" : "#ffffff",
                  }}
                >
                  {proposal.user ? (
                    <>
                      Created By: <b>{proposal.user}</b>
                    </>
                  ) : proposal.repGen === "1" ? (
                    <>
                      Created By: <b>Sales Rep</b>
                    </>
                  ) : (
                    <>
                      Created By: <b>Proposals</b>
                    </>
                  )}
                  <>
                    &nbsp; | &nbsp;<b>{proposal.timeStamp}</b> &nbsp; | &nbsp;
                    Proposal ID: <b>{proposal.propId}</b>
                    {proposal.auroraDesignId ? <span style={{fontSize:"10px"}}><br></br> Aurora Design ID: <b>{proposal.auroraDesignId}</b></span> : null}
                  </>
                </span>
              </div>
            </div>

            <div className="row">
              <div
                className="col-3 pt-2"
                style={{ borderRight: "1px solid #adadad" }}
              >
                <p className="mb-0">
                  <b>Status:</b>

                  {+syncPropId === +proposal.propId ? (
                    <span className="text-success"> Active Proposal</span>
                  ) : (
                    <span className="text-danger"> Inactive</span>
                  )}
                </p>
                <p className="mb-0">
                  <b>Rebate:</b> ${proposal.rebate}
                </p>
                <p className="mb-0">
                  {" "}
                  {proposal.utility === "Austin Energy" ||
                  proposal.utility.includes("Xcel Energy")
                    ? (
                        (+proposal.loanAmount + +proposal.downPayment) /
                        +proposal.systemSize
                      ).toLocaleString(undefined, {
                        style: "currency",
                        currency: "USD",
                      }) + "/watt"
                    : proposal.rebateOverride === "1"
                      ? "$" + (+proposal.ppw).toFixed(2) + "/watt"
                      : (
                          (+proposal.loanAmount +
                            +proposal.downPayment +
                            +proposal.rebate) /
                          +proposal.systemSize
                        ).toLocaleString(undefined, {
                          style: "currency",
                          currency: "USD",
                        }) + "/watt"}
                </p>

                <p>
                  {+proposal.costOverRide > 0
                    ? "$" +
                      (
                        (+proposal.totalSystemCost - +proposal.adderTotal) /
                        +proposal.systemSize
                      ).toFixed(2) +
                      "/watt before adders"
                    : "$" + (+proposal.ppw).toFixed(2) + "/watt before adders"}
                </p>
              </div>

              <div
                className="col-3 pt-2"
                style={{ borderRight: "1px solid #adadad" }}
              >
                <p className="mb-0">
                  <b>System Size:</b> {proposal.systemSize / 1000} kW
                </p>
                <p className="mb-0">
                  <b>Offset:</b>{" "}
                  {usageType !== "Square Footage" && <span>{offset()}%</span>}
                </p>
                <p className="mb-0">
                  <b>Panels:</b> {proposal.modCount}{" "}
                </p>
                <p className="mb-0">
                  <b>Production:</b> {totalProduction.toLocaleString()} kWh
                </p>
              </div>

              <div
                className="col-2 pt-2"
                style={{ borderRight: "1px solid #adadad" }}
              >
                <p className="mb-0 text-center">
                  <b>Adders</b>
                </p>

                <Adders
                  proposal={proposal}
                  customer={customer}
                  dealerFee={dealerFee}
                  props={props}
                  apiUrl={apiUrl}
                />
              </div>

              <div className="col-2 pt-2">
                <CopyToClipboard onCopy={() => setCopied(true)} text={monthly}>
                  <button
                    type="button"
                    className="btn btn-sm btn-info w-100 mb-1 text-white"
                  >
                    <i className="bi bi-clipboard"></i> Copy Production
                  </button>
                </CopyToClipboard>

                <CopyToClipboard
                  onCopy={() => {
                    setCopied(true);
                    copier();
                  }}
                  text={`https://proposalist.iondeveloper.com/?proj_id=${
                    proposal.projectId
                  }#/propview/${proposal.propId}/${i + 1}/1`}
                >
                  <button
                    type="button"
                    className="btn btn-sm btn-info w-100 mb-1 text-white"
                  >
                    <i className="bi bi-clipboard"></i> Copy Rep Link
                  </button>
                </CopyToClipboard>

                <button
                  type="button"
                  className="btn btn-sm btn-info w-100 mb-1 text-white"
                  onClick={() =>
                    window.open(
                      `https://proposalist.iondeveloper.com/?proj_id=${
                        proposal.projectId
                      }#/propview/${proposal.propId}/${i + 1}/1`,
                      "_blank",
                    )
                  }
                >
                  <i className="bi bi-arrow-up-circle"></i> Open Rep Link
                </button>
                {+syncPropId === +proposal.propId && (
                  <button
                    type="button"
                    className="btn btn-sm btn-info w-100 mb-1 text-white"
                    style={{ backgroundColor: "#856cff", borderColor: "#856cff" }}
                    onClick={async () => {
                      setGlDvChangeOrderModal(proposal.propId);
                      setGlDvChangeOrderLoading(true);
                      setGlDvChangeOrderResponse(null);
                      try {
                        const response = await goodLeapApi.request({
                          method: "design_only_change_order",
                          sf_project_id: proposal.projectId,
                        });
                        setGlDvChangeOrderResponse(response);
                      } catch (error) {
                        setGlDvChangeOrderResponse({
                          error: true,
                          message: error.message || error.response?.data?.message || "Failed to submit change order",
                        });
                      } finally {
                        setGlDvChangeOrderLoading(false);
                      }
                    }}
                  >
                    <i className="bi bi-arrow-clockwise"></i> GL DV Only CO
                  </button>
                )}
              </div>

              <div className="col-2 pt-2">
                {props.edit ? (
                  <button
                    type="button"
                    className="btn btn-sm btn-info w-100 mb-1 text-white"
                    onClick={() => cloneProp()}
                  >
                    <i className="bi bi-copy"></i> Clone
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary w-100 mb-1 text-white"
                    disabled
                  >
                    <i className="bi bi-copy"></i> Clone
                  </button>
                )}

                <Link
                  target="_blank"
                  to={`/customerpropview/${proposal.propId}/${i + 1}/39423`}
                >
                  <button
                    type="button"
                    className="btn btn-sm btn-info w-100 mb-1 text-white"
                  >
                    <i className="bi bi-arrow-up-circle"></i> View Proposal
                  </button>
                </Link>

                <button
                  type="button"
                  className="btn btn-sm btn-info w-100 mb-1 text-white"
                  onClick={() =>
                    window.open(
                      `https://dev.iondeveloper.com/api/proposal/generatePDF/proposalv2.php?propId=${proposal.propId}&projectId=${proposal.projectId}`,
                      "_blank",
                    )
                  }
                >
                  <i className="bi bi-arrow-down-circle"></i> Download PDF
                </button>
                {+syncPropId === +proposal.propId && (
                  <button
                    type="button"
                    className="btn btn-sm btn-info w-100 mb-1 text-white"
                    style={{ backgroundColor: "#856cff", borderColor: "#856cff" }}
                    onClick={async () => {
                      setGlFullChangeOrderModal(proposal.propId);
                      setGlFullChangeOrderLoading(true);
                      setGlFullChangeOrderResponse(null);
                      try {
                        const response = await goodLeapApi.request({
                          method: "goodleap_change_order",
                          sf_project_id: proposal.projectId,
                        });
                        setGlFullChangeOrderResponse(response);
                      } catch (error) {
                        setGlFullChangeOrderResponse({
                          error: true,
                          message: error.message || error.response?.data?.message || "Failed to submit change order",
                        });
                      } finally {
                        setGlFullChangeOrderLoading(false);
                      }
                    }}
                  >
                    <i className="bi bi-arrow-clockwise"></i> GL Full CO
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    });

  return (
    <section
      name="proposals"
      className="pt-2"
      style={{ backgroundColor: "#cfdde3" }}
    >
      <div className="container">
        {customer ? (
          <>
            <div className="row">
              <div className="col-12 pb-2">
                <span className="float-end">
                  <button
                    type="button"
                    className="btn btn-outline-dark"
                    onClick={() => adderToggle(active, setActive)}
                  >
                    {active === 1 ? `View Archived` : `View Active`}
                  </button>
                </span>
              </div>
            </div>

            {mappedProposals}
            <div className="row">
              <div className="col-12 pb-2">
                <span className="float-end">
                  <button
                    type="button"
                    className="btn btn-outline-dark"
                    onClick={() => adderToggle(active, setActive)}
                  >
                    {active === 1 ? `View Archived` : `View Active`}
                  </button>
                </span>
              </div>
            </div>

            <Modal
              isOpen={glDvChangeOrderModal !== null}
              onClose={() => {
                setGlDvChangeOrderModal(null);
                setGlDvChangeOrderResponse(null);
                setGlDvChangeOrderLoading(false);
              }}
              title="GL DV Change Order"
              showCloseButton={true}
              closeOnOverlayClick={true}
              className="small"
            >
              {glDvChangeOrderLoading || !glDvChangeOrderResponse ? (
                <div style={{ textAlign: "center", padding: "40px 20px" }}>
                  <CircularProgress size={50} color="inherit" />
                  <p style={{ marginTop: "15px", fontSize: "14px" }}>
                    Submitting change order...
                  </p>
                </div>
              ) : glDvChangeOrderResponse.error ? (
                <div style={{ padding: "20px" }}>
                  <div style={{ color: "red" }}>
                    <h5>Error:</h5>
                    <p>{glDvChangeOrderResponse.message}</p>
                  </div>
                </div>
              ) : (
                <div style={{ padding: "20px" }}>
                  <h5>Response:</h5>
                  <pre
                    style={{
                      backgroundColor: "#f5f5f5",
                      padding: "15px",
                      borderRadius: "5px",
                      overflow: "auto",
                      maxHeight: "400px",
                      fontSize: "12px",
                    }}
                  >
                    {JSON.stringify(glDvChangeOrderResponse, null, 2)}
                  </pre>
                </div>
              )}
            </Modal>

            <Modal
              isOpen={glFullChangeOrderModal !== null}
              onClose={() => {
                setGlFullChangeOrderModal(null);
                setGlFullChangeOrderResponse(null);
                setGlFullChangeOrderLoading(false);
              }}
              title="GL Full Change Order"
              showCloseButton={true}
              closeOnOverlayClick={true}
              className="small"
            >
              {glFullChangeOrderLoading || !glFullChangeOrderResponse ? (
                <div style={{ textAlign: "center", padding: "40px 20px" }}>
                  <CircularProgress size={50} color="inherit" />
                  <p style={{ marginTop: "15px", fontSize: "14px" }}>
                    Submitting change order...
                  </p>
                </div>
              ) : glFullChangeOrderResponse.error ? (
                <div style={{ padding: "20px" }}>
                  <div style={{ color: "red" }}>
                    <h5>Error:</h5>
                    <p>{glFullChangeOrderResponse.message}</p>
                  </div>
                </div>
              ) : (
                <div style={{ padding: "20px" }}>
                  <h5>Response:</h5>
                  <pre
                    style={{
                      backgroundColor: "#f5f5f5",
                      padding: "15px",
                      borderRadius: "5px",
                      overflow: "auto",
                      maxHeight: "400px",
                      fontSize: "12px",
                    }}
                  >
                    {JSON.stringify(glFullChangeOrderResponse, null, 2)}
                  </pre>
                </div>
              )}
            </Modal>

            {showAuroraDesignModal && currentAuroraProposal && (
              <AuroraDesignListModal
                show={showAuroraDesignModal}
                onHide={() => {
                  setAuroraLoading(false);
                  setShowAuroraDesignModal(false);
                  setCurrentAuroraProposal(null);
                }}
                sfProjectId={currentAuroraProposal.projectId}
                currentDesignId={currentAuroraProposal.auroraDesignId}
                designs={auroraDesignList}
                syncDesign={() => getAuroraDesignData(currentAuroraProposal)}
              />
            )}
          </>
        ) : (
          <>
            <div className="loading-box2">
              <CircularProgress size={50} color="inherit" />
            </div>
          </>
        )}
      </div>
    </section>
  );
};
export default Proposals;
